import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    titleContainer: {
        marginBottom: theme.spacing(5),
    },
    formContainer: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
    },
    footerText: {
        color: theme.palette.emteria.text.secondary,
        textAlign: "center",
    },
    infoText: {
        display: "flex",
        flexDirection: "column",
        fontSize: 16,
        textAlign: "center",
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5),
    },
}));
